import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPostcard1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"postcard-1,address"} maskId="square-filled-radius-0-stroke-1-IconPostcard1"><path fillRule="evenodd" clipRule="evenodd" d="M2 4H22V20H2V4ZM5 8L11 8V9L5 9V8ZM19 8V14L14 14V8L19 8ZM5 11L8 11V12L5 12L5 11Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconPostcard1;
